<script>
import { UploadableFile } from "./uploadable-file";
export default {
  name: "AppDropFile",
  props: {
    accept: {
      type: String,
      default: ".pdf,.jpg,.jpeg,.png",
    },
    maxSize: {
      type: Number,
      default: 10 * 1024 * 1024,
    },
    multiple: {
      type: Boolean,
      default: true,
    },
    disable: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isDragging: false,
      files: [],
    };
  },
  methods: {
    dragover(e) {
      e.preventDefault();
      this.isDragging = true;
      clearTimeout(this.dragTimeout);
      this.dragTimeout = null;
    },
    dragleave(e) {
      e.preventDefault();
      if (this.dragTimeout) clearTimeout(this.dragTimeout);
      this.dragTimeout = setTimeout(() => {
        this.isDragging = false;
        this.dragTimeout = null;
      }, 100);
    },
    drop(e) {
      e.preventDefault();
      this.isDragging = false;
      this.$refs.input.files = e.dataTransfer.files;
      this.onChange();
    },
    onChange() {
      const uploadableFiles = [...this.$refs.input.files]
        .map((file) => {
          return new UploadableFile(file);
        })
        .filter((file) => !this.fileExists(file) && this.checkFileSize(file));
      this.files = [...uploadableFiles, ...this.files];
      this.emitFiles();
    },
    fileExists(file) {
      return this.files.some((f) => f.id === file.id);
    },
    checkFileSize(file) {
      if (file.size > this.maxSize) {
        this.$emit(
          "error",
          new Error(
            `O arquivo ${file.name} ultrapassa o limite de ${
              this.maxSize / 1024 / 1024
            }MB`
          )
        );
        return false;
      }
      return true;
    },
    removeFile(file) {
      this.$refs.input.value = "";
      this.files = this.files.filter((f) => f.id !== file.id);
      this.emitFiles();
    },
    emitFiles() {
      this.$emit(
        "change",
        this.files.map((file) => file.file)
      );
    },
  },
};
</script>

<template>
  <div class="container">
    <label
      v-show="!disable"
      class="file-upload"
      :class="isDragging ? 'dragging' : ''"
      @dragenter.prevent="dragover"
      @dragover.prevent="dragover"
      @dragleave.prevent="dragleave"
      @drop.prevent="drop"
    >
      <span v-if="isDragging">Solte para adicionar os arquivos</span>
      <span v-else>
        Arraste e Solte ou
        <span class="choose-file">Escolha um arquivo</span> para enviar
      </span>
      <input
        ref="input"
        class="file-input"
        type="file"
        name="file"
        :multiple="multiple"
        :accept="accept"
        @change="onChange"
        :disabled="disable"
      />
    </label>

    <div class="file-list">
      <div
        v-for="file in files"
        :key="file.id"
        class="file-item"
      >
        <div class="file-info">
          <svg class="svg-icon svg-code" width="36" height="36" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 36 36">
            <path fill="currentColor" fill-rule="evenodd"
                  d="M7.2 7.2a3.6 3.6 0 0 1 3.6-3.6h8.255A3.6 3.6 0 0 1 21.6 4.654l6.146 6.146a3.6 3.6 0 0 1 1.054 2.546V28.8a3.6 3.6 0 0 1-3.6 3.6H10.8a3.6 3.6 0 0 1-3.6-3.6V7.2Z"
                  clip-rule="evenodd" />
          </svg>

          <div class="file-details">
            <p class="file-name">{{ file.name }}</p>
            <span class="file-type">{{ file.type?.split("/")[1] }}</span>
          </div>
        </div>
        <button
          class="remove-file-button"
          @click="removeFile(file)"
        >
          <svg class="text-grey-400" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M6 18L18 6M6 6L18 18" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                  stroke-linejoin="round" />
          </svg>

        </button>
      </div>
    </div>
  </div>

</template>

<style scoped lang="stylus">
.container
  display flex
  flex-direction column
  gap 1rem
  padding 0

.file-upload
  cursor pointer
  border-radius: 0.5rem
  padding 1.7rem
  text-align center
  font-weight 500
  transition all 0.3s
  border 2px dotted rgb(229, 231, 235)
  background-color rgb(247, 247, 247)

.file-upload span
  font-size 16px

.file-upload:hover
  background-color white

.file-upload.dragging
  border-color #d69e2e
  background-color: #fffbeb

.file-upload .choose-file
  color rgb(5, 112, 170)

.file-input
  position absolute
  height 1px
  width 1px
  overflow hidden
  opacity 0

.file-list
  display flex
  flex-direction column
  gap 0.5rem

.file-item
  display flex
  align-items center
  justify-content space-between
  background-color rgb(247, 247, 247)
  border-radius 0.5rem
  padding 0.75rem

.file-info
  display flex
  align-items center
  gap 0.25rem

.file-details
  display flex
  flex-direction column
  gap 0.25rem

.file-name
  font-size 0.875rem
  font-weight 500
  line-height 1
  margin-bottom 0.5rem

.file-type
  color rgb(77, 77, 77)
  font-size 0.75rem
  text-transform uppercase
  line-height 1

.remove-file-button
  display flex
  height 2rem
  width 2rem
  align-items center
  justify-content center
  border-radius 0.5rem
  background-color transparent
  cursor pointer
  border none

.remove-file-button:hover
  background-color rgba(0, 0, 0, 0.05)
</style>
